// import './googleMaps';

import $ from 'jquery';
import './accordion';
import './dropDown';
import './mobileMenu';
import './slick';
import './tabs';
import './typewriter';

// Slide out menu
const hamburger = document.querySelector('.a-hamburger');
const slideOut = document.querySelector('.m-slideOut');

function menuToggle(event) {
  event.preventDefault();
  hamburger.classList.toggle('open');
  slideOut.classList.toggle('open');
}

hamburger.addEventListener('touchstart', menuToggle, {
  // passive: true,
});

hamburger.addEventListener('click', menuToggle);

// Slick - Client Carousel
$('.m-gallery--clients').slick({
  dots: true,
  prevArrow: false,
  nextArrow: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  rows: 2,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6,
      },
    },
  ]
});

// Slick - Post Gallery
$('.m-gallery--slick').slick({
  dots: false,
  prevArrow: false,
  nextArrow: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true
});

// Slick - Testimonials
$('.m-testimonials--slick').slick({
  dots: true,
  prevArrow: false,
  nextArrow: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  dotsClass: 'slick-dots slick-dots--black slick-dots--testimonial',
});

// Slick - Text Overlay Cards
$('.t-cards__slick').slick({
  dots: false,
  prevArrow: false,
  nextArrow: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1.2,
  slidesToScroll: 1,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2.5,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3.5,
      },
    },
    {
      breakpoint: 1024,
      settings: "unslick"
    },
  ]
});

// Reduce padding on first section.
const section = document.querySelector('section');
const bodyClass = document.querySelector('.error404');

if (!bodyClass) {
  section.style.paddingTop = '0';
}

// Insight form download - When download button is clicked - PDF opens in new tab.
const insightForm = $('.o-post--insights .m-form form');

if (insightForm.length) {
  $('.o-post--insights .m-form form').submit(function () {
    $('.o-post--insights .m-form .insight__download').trigger('click');
  });

  $('.o-post--insights .m-form .insight__download').click(function () {
    const pdf = $(this).prop('href');
    window.open(pdf, '_blank');
  });
}
